var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.market.odd && Object.values(_vm.market.odd).length <= 3)?_c('row',{attrs:{"odd":_vm.market,"match":_vm.match,"selectedOdds":_vm.selectedOdds}}):_vm._e(),_vm._v(" "),(_vm.market.odd && Object.values(_vm.market.odd).length > 3)?_c('block',{attrs:{"odd":_vm.market,"match":_vm.match,"selectedOdds":_vm.selectedOdds}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78eb1670","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sportsbook/market/market.vue
// module id = PZpw
// module chunks = 0